import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { LogoMark } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success(data.message || "Password aggiornata!");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 tw-grain">
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-5 py-10">
        <div className="mb-4 flex justify-center"><LogoMark className="h-28 w-28 object-contain" /></div>
        <div className="rounded-3xl border-2 border-zinc-950 bg-white p-6 shadow-[6px_6px_0_0_#09090b]">
          <h1 className="font-display text-3xl font-black uppercase text-zinc-950">Nuova password</h1>
          {!token ? (
            <p className="mt-4 text-sm text-red-500">Link non valido. Richiedi un nuovo reset.</p>
          ) : (
            <form onSubmit={submit} className="mt-4 space-y-4">
              <div className="space-y-1.5">
                <Label>Nuova password</Label>
                <Input data-testid="reset-password-input" type="password" required minLength={6} value={password}
                  onChange={(e) => setPassword(e.target.value)} className="rounded-xl" />
              </div>
              <Button data-testid="reset-submit-button" type="submit" disabled={loading}
                className="w-full rounded-full bg-green-500 py-6 font-black uppercase text-zinc-950 hover:bg-green-600">
                {loading ? "Aggiornamento..." : "Imposta password"}
              </Button>
            </form>
          )}
          <p className="mt-4 text-center text-sm"><Link to="/login" className="font-semibold text-zinc-500 hover:text-zinc-950">Torna al login</Link></p>
        </div>
      </div>
    </div>
  );
}
